import React from 'react';
import styles from '@/styles/components/tools/ToolCard.module.css';

export interface ToolCardProps {
  title: string;
  description: string;
  tags: string[];
  onRun: () => void;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, description, tags, onRun }) => {
  return (
    <article className={styles.card} aria-label={title}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>

      <ul className={styles.tagsRow} aria-label={`${title} tags`}>
        {tags.map(tag => (
          <li key={tag} className={styles.tag}>
            <span className={styles.tagText}>{tag}</span>
          </li>
        ))}
      </ul>

      <div className={styles.splitterLine} />

      <div className={styles.footer}>
        <button type="button" className={styles.runButton} onClick={onRun}>
          Run agent
        </button>
      </div>
    </article>
  );
};

export default ToolCard;

